import { defaultChipRenderingOptions } from './default-chip-rendering-options';

export const TEXT_CHIP_RENDERING_OPTIONS = defaultChipRenderingOptions<string>(text => text);
